import {
  ensure,
  wrapErrors,
  notEmpty,
  ensureProperties,
  itsProperty,
  validateNotOverlapingOf,
} from "../Common/composition";
import SelectAvailableDevice from "./SelectAvailableDevice";
const compare = (one, another) => one.interface === another.interface;
const describe = (interface_) => `device ${interface_}`;

const validateInterface = wrapErrors(
  (error) => `interface ${error}`,
  ensure(notEmpty)
);

const validateInterfaceEntry = wrapErrors(
  (error) => `Interfaces ${error}`,
  ensure(
    ensureProperties(itsProperty("interface", validateInterface)),
    validateNotOverlapingOf(compare, describe)
  )
);

const listPresentInterfacesAsString = ({
  added = [],
  updated = [],
  keeped = [],
}) =>
  [...keeped, ...added, ...updated].map((item) => item["interface"]).join(" ");

export const interfaceComposition = {
  cliType: "interface",
  typeLabel: "Interface",
  viewURL: "viewInterfaceProfileConfig",
  expectClear: true,
  expectSet: true,
  fields: [
    { name: "name", label: "Profile name", type: "text", canUpdate: true },
    {
      name: "interfaces",
      cliName: "interface-id",
      label: "input interfaces",
      labelSingle: "input interface",
      type: "many",
      cliExpressAs: listPresentInterfacesAsString,
      canBeEmpty: false,
      validate: validateInterfaceEntry,
      fields: [
        {
          name: "interface",
          label: "Interface",
          type: "select",
          InputComponent: SelectAvailableDevice,
          editionClassName: "full-width",
          validate: validateInterface,
        },
      ],
    },
  ],
};

export default interfaceComposition;
